import Persona from 'persona'
import ShipbobAppSettings from '@/appSettings/appSetting'
import { getTelemetryInstance } from '@/telemetry'
import { store } from '@/store'

const init = (userId, inquiryId, sessionToken) => {
  const client = new Persona.Client({
    referenceId: userId,
    inquiryId,
    sessionToken,
    environmentId: ShipbobAppSettings.KYC.environmentId,
    onComplete: ({ inquiryId, status, fields }) => {
      store.dispatch('user/getUserOrgKYC')
      getTelemetryInstance()?.trackEvent({
        name: 'USER_KYC_COMPLETE',
        properties: {
          userId,
          inquiryId,
          status,
          fields
        }
      })
    },
    onCancel: ({ inquiryId, sessionToken }) => {
      store.dispatch('user/getUserOrgKYC')
      getTelemetryInstance()?.trackEvent({
        name: 'USER_KYC_CANCELLED',
        properties: {
          userId,
          inquiryId,
          sessionToken
        }
      })
    },
    onEvent: (eventName, metadata) => {
      getTelemetryInstance()?.trackEvent({
        name: 'USER_KYC_EVENT',
        properties: {
          userId,
          eventName,
          metadata
        }
      })
    },
    onError: (error) => {
      getTelemetryInstance()?.trackException({
        exception: error,
        severityLevel: 3
      }, {
        custom: 'USER_KYC_ERROR'
      })
    }
  })

  return client
}

export default {
  init
}
